import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  public copyrightYear: number;

  constructor() { }

  ngOnInit(): void {
    this.updateYear();
  }

  updateYear() {
    this.copyrightYear = (new Date()).getFullYear();
  }
}
